export const UPDATE = 'UPDATE_MY_PATIENTS';
